"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTagOfNode_1 = require("../utils/getTagOfNode");
function getListTypeFromNode(node) {
    switch (getTagOfNode_1.default(node)) {
        case 'OL':
            return 1 /* Ordered */;
        case 'UL':
            return 2 /* Unordered */;
        default:
            return 0 /* None */;
    }
}
exports.default = getListTypeFromNode;
/**
 * @internal
 * Check if the given DOM node is a list element (OL or UL)
 * @param node The node to check
 */
function isListElement(node) {
    return getListTypeFromNode(node) != 0 /* None */;
}
exports.isListElement = isListElement;
//# sourceMappingURL=getListTypeFromNode.js.map